
    
    <template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_notifications" autocomplete="off">
                <v-layout row wrap>
                    
        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="notifications.notification_from" :label="$store.getters.lang.data.notification_from"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="notifications.notification_to" :label="$store.getters.lang.data.notification_to"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="notifications.notification_text" :label="$store.getters.lang.data.notification_text"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="date" v-model="notifications.notification_date" :label="$store.getters.lang.data.notification_date"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="notifications.item_id" :label="$store.getters.lang.data.item_id"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        


        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="number" v-model="notifications.comment_id" :label="$store.getters.lang.data.comment_id"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        

    
    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1"  type="submit" x-large>{{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>    
                </v-layout>
            </form>
        </v-container>
        
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/notifications'
    export default {
        data() {
            return {
                notifications: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {
            
            
        },
        methods: {
            get_notifications() {
                this.loading = true
                controller.getOne(this.id).then(r =>{
                    this.notifications = r.data.row
                    this.loading = false
                }).catch(e =>{
                    console.log(e);
                })
            },
            update_notifications() {
                controller.update_notifications(this.notifications).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },
            
        },
        mounted() {
            this.id = this.$route.params.id
            this.get_notifications()
        },
    }
</script>
    
    